import { compose } from 'recompose'

import withTranslation from '../../../../../globals/components/withTranslation'
import withPermissions from '../../../../../globals/components/withPermissions'
import Component from './component'
import { UserNoteProps } from './types'
import { withRouter } from 'react-router-dom'

export default compose(withPermissions, withTranslation, withRouter)(Component)
